import type { Translation } from '../../types';
import type { nav as en } from '../en/nav';

export const nav: Translation<typeof en> = {
  sections: {
    business: 'Kinh doanh',
    compliance: 'Tuân thủ',
    registry: 'Vận hành Registry',
    ops: 'Vận hành hệ thống',
    settings: 'Cấu hình tích hợp',
    admin: 'Quản trị',
  },
  groups: {
    compliance_vnnic: 'Báo cáo nhà nước',
    compliance_icann: 'ICANN',
  },
  items: {
    '/domains': { label: 'Tên miền', description: 'Tìm kiếm, lọc và thao tác hàng loạt trên danh mục tên miền.' },
    '/customers': { label: 'Khách hàng', description: 'Tài khoản khách hàng, người dùng và quyền truy cập.' },
    '/subjects': { label: 'Chủ thể', description: 'Chủ thể đăng ký (cá nhân, tổ chức) đứng sau tên miền.' },
    '/dossiers': { label: 'Hồ sơ', description: 'Hồ sơ tên miền — bắt buộc cho mọi tên miền quản lý (.vn, gTLD, new gTLD, ccTLD).' },
    '/documents': { label: 'Giấy tờ', description: 'Giấy tờ định danh và đăng ký gắn với hồ sơ.' },
    '/quotes': { label: 'Báo giá', description: 'Báo giá đã gửi cho khách hàng.' },
    '/orders': { label: 'Đơn hàng', description: 'Đơn hàng, hạng mục, thanh toán và xử lý.' },
    '/billing': { label: 'Thanh toán', description: 'Tổng quan số dư ví, tạm giữ, thanh toán và hoá đơn.' },
    '/ledger': { label: 'Ví / Sổ cái', description: 'Sổ cái kép và ví khách hàng. Sổ cái luôn phải cân bằng về 0.' },
    '/payments': { label: 'Giao dịch thanh toán', description: 'Thanh toán, lần thử, callback và hoàn tiền.' },
    '/invoices': { label: 'Hoá đơn', description: 'Hoá đơn và phát hành hoá đơn điện tử Việt Nam.' },
    '/pricing': { label: 'Bảng giá', description: 'Giá registry, bảng giá bán, tỷ giá và thuế.' },
    '/promotions': { label: 'Khuyến mãi', description: 'Chương trình khuyến mãi và mức sử dụng.' },
    '/auctions': { label: 'Đấu giá', description: 'Đấu giá công khai và đấu giá giữa những người đặt giữ: lượt trả giá, kết quả, lịch sử.' },
    '/backorders': { label: 'Đặt giữ tên miền', description: 'Yêu cầu đặt giữ tên miền, tên miền sắp được giải phóng và các lần giành đăng ký (drop-catch).' },
    '/compliance/vnnic/dossier-sync': { label: 'Đồng bộ hồ sơ', description: 'Đồng bộ hồ sơ chủ thể với VNNIC cho tên miền .vn.' },
    '/compliance/vnnic/international-reports': { label: 'Báo cáo quốc tế', description: 'Báo cáo tên miền quốc tế do chủ thể Việt Nam nắm giữ.' },
    '/compliance/vnnic/coverage': { label: 'Độ phủ / Sai lệch', description: 'Tên miền nào đã đồng bộ/báo cáo, và chỗ nào dữ liệu khác VNNIC.' },
    '/compliance/vnnic/corrections': { label: 'Đính chính', description: 'Hồ sơ VNNIC từ chối hoặc yêu cầu sửa, và các lần sửa báo cáo.' },
    '/compliance/vnnic/post-operations': { label: 'Sau nghiệp vụ', description: 'Yêu cầu của đuôi tên miền sau mỗi nghiệp vụ registry: NĐK ký, đồng bộ hồ sơ, báo cáo biến động.' },
    '/compliance/vnnic/registrar-signature': { label: 'Chờ NĐK ký', description: 'Hồ sơ chờ nhà đăng ký ký số và các lô ký hằng ngày.' },
    '/compliance/vnnic/tracking-reports': { label: 'Báo cáo hằng ngày', description: 'Báo cáo theo dõi tên miền .vn hằng ngày gửi VNNIC: số yêu cầu và số cấp theo kênh.' },
    '/compliance/icann/rdap': { label: 'RDAP', description: 'Bật/tắt RDAP, chính sách công bố và xem thử tra cứu.' },
    '/compliance/icann/rde': { label: 'RDE', description: 'Các bản ký quỹ dữ liệu đăng ký (escrow).' },
    '/compliance/icann/disclosure': { label: 'Cung cấp dữ liệu', description: 'Yêu cầu cung cấp dữ liệu đăng ký.' },
    '/compliance/icann/abuse': { label: 'Lạm dụng', description: 'Vụ việc lạm dụng, chứng cứ, yêu cầu của cơ quan chức năng và xử lý tên miền.' },
    '/compliance/icann/disputes': { label: 'Tranh chấp', description: 'UDRP / URS, lệnh toà án và tranh chấp khác cùng khoá pháp lý.' },
    '/compliance/cases': { label: 'Hộp vụ việc', description: 'Vụ việc lạm dụng, tranh chấp và cung cấp dữ liệu trong một hàng đợi.' },
    '/compliance/legal-locks': { label: 'Khoá pháp lý', description: 'Khoá theo lệnh toà án, cơ quan chức năng và registry.' },
    '/registry/registries': { label: 'Registry', description: 'Các registry, vùng tên miền, kết nối và tình trạng.' },
    '/registry/tlds': { label: 'TLD', description: 'Tên miền cấp cao nhất và số tên miền đang quản lý.' },
    '/registry/epp': { label: 'EPP', description: 'Cấu hình kết nối EPP của từng registry.' },
    '/registry/sessions': { label: 'Phiên EPP', description: 'Nhóm phiên EPP và lưu lượng gần đây.' },
    '/registry/transactions': { label: 'Giao dịch registry', description: 'Mọi lệnh EPP kèm clTRID / svTRID và kết quả.' },
    '/registry/poll': { label: 'Thông báo poll', description: 'Hàng đợi thông báo poll từ registry.' },
    '/registry/reconciliation': { label: 'Đối soát', description: 'Xử lý kết quả UNKNOWN và sai lệch so với dữ liệu registry.' },
    '/ops/overview': { label: 'Tổng quan', description: 'Các chỉ số sức khoẻ chính của hệ thống.' },
    '/ops/services': { label: 'Dịch vụ', description: 'Các dịch vụ được giám sát và trạng thái hoạt động.' },
    '/ops/registries': { label: 'Sức khoẻ registry', description: 'Kết nối, độ trễ và tỷ lệ lỗi theo registry.' },
    '/ops/queues': { label: 'Hàng đợi', description: 'Hàng đợi công việc, sự kiện chờ gửi và workflow đang chạy.' },
    '/ops/workflows': { label: 'Workflow', description: 'Danh sách workflow và lịch sử từng bước.' },
    '/ops/metrics': { label: 'Metric', description: 'Truy vấn metric của nền tảng tại một thời điểm hoặc theo khoảng thời gian.' },
    '/ops/logs': { label: 'Log', description: 'Tìm kiếm log và theo dõi trực tiếp.' },
    '/ops/traces': { label: 'Trace', description: 'Tìm trace và biểu đồ span.' },
    '/ops/alerts': { label: 'Cảnh báo', description: 'Cảnh báo đang kích hoạt, theo nhóm, kèm tạo sự cố.' },
    '/ops/incidents': { label: 'Sự cố', description: 'Vòng đời sự cố.' },
    '/contacts': { label: 'Liên hệ', description: 'Đối tượng liên hệ tại registry (chủ thể, quản trị, kỹ thuật, thanh toán) và các tên miền dùng chúng.' },
    '/transfers': { label: 'Chuyển đổi nhà đăng ký', description: 'Chuyển tên miền đến và đi, cùng trạng thái xử lý.' },
    '/registrant-changes': { label: 'Đổi chủ thể', description: 'Thay đổi chủ thể đăng ký, kèm phê duyệt và khoá chuyển.' },
    '/compliance/policies': { label: 'Chính sách', description: 'Các chính sách tuân thủ theo phiên bản và ngày hiệu lực.' },
    '/compliance/work': { label: 'Việc cần xử lý', description: 'Mọi việc cần người xử lý: duyệt eKYC, hồ sơ và các ngoại lệ vận hành.' },
    '/compliance/deadlines': { label: 'Hạn tuân thủ', description: 'Các hạn báo cáo với VNNIC, ICANN và tình trạng đáp ứng.' },
    '/settings/registries': { label: 'Kết nối registry', description: 'Cách kết nối tới từng registry: EPP, REST API của registry, hoặc qua nhà đăng ký trung gian.' },
    '/settings/tlds': { label: 'Kênh đăng ký TLD', description: 'Mỗi TLD được đăng ký qua kết nối nào.' },
    '/settings/vnnic': { label: 'Tích hợp VNNIC', description: 'Cấu hình Registrar API, eKYC, API hồ sơ (HSTM) và API báo cáo gTLD của VNNIC.' },
    '/settings/email': { label: 'E-mail & mẫu thư', description: 'Cấu hình gửi thư, thương hiệu và mẫu e-mail; khách hàng có hạng cho phép tự cấu hình ở trang khách hàng.' },
    '/settings/tld-settings': { label: 'Cấu hình TLD', description: 'Điều kiện chuyển về, khôi phục, hết hạn theo TLD và máy chủ tên tạm.' },
    '/domain-services': { label: 'Dịch vụ tên miền', description: 'Dịch vụ vòng đời và dịch vụ thêm: danh mục, giá và loại thuế.' },
    '/name-changes': { label: 'Đổi tên / chuyển nhượng', description: 'Đổi tên chủ thể và chuyển nhượng tên miền .vn: hồ sơ, duyệt, bước nhập trên hệ thống VNNIC.' },
    '/settings/name-change-requirements': { label: 'Hồ sơ đổi tên', description: 'Giấy tờ cần có theo từng trường hợp đổi tên / chuyển nhượng (theo phiên bản).' },
    '/compliance/protected': { label: 'Tên miền bảo vệ', description: 'Tên miền bảo vệ cần xử lý: thay đổi chờ xác nhận và giai đoạn hết hạn.' },
    '/settings/webhooks': { label: 'Webhook', description: 'Sự kiện có ký gửi tới hệ thống của bạn (ví dụ CRM), kèm nhật ký gửi.' },
    '/settings/email-log': { label: 'Thư đã gửi', description: 'Mọi thông báo đã gửi hoặc đang chờ gửi, kèm nội dung đã gửi.' },
    '/admin/staff': { label: 'Nhân viên', description: 'Tài khoản nhân viên, trạng thái MFA và vai trò được gán.' },
    '/admin/roles': { label: 'Vai trò & quyền', description: 'Các vai trò và quyền mà mỗi vai trò cấp.' },
    '/admin/approvals': { label: 'Phê duyệt', description: 'Yêu cầu phê duyệt bốn mắt đang chờ người thứ hai.' },
    '/admin/api-credentials': { label: 'Khoá truy cập API', description: 'Khoá truy cập API cấp cho khách hàng.' },
    '/admin/audit': { label: 'Nhật ký kiểm toán', description: 'Ai đã làm gì, khi nào và vì sao trên toàn hệ thống.' },
    '/ops/slo': { label: 'SLO', description: 'Mục tiêu chất lượng dịch vụ và ngân sách lỗi.' },
  },
  hubs: {
    home: {
      label: 'Việc cần xử lý',
      description: 'Mọi việc đang chờ người xử lý: hồ sơ tên miền cần duyệt để kích hoạt, hàng việc, tên miền bảo vệ, phê duyệt, hạn tuân thủ và yêu cầu của khách.',
      tabs: { dossiers: 'Hồ sơ tên miền', queue: 'Việc cần xử lý', protected: 'Tên miền bảo vệ', approvals: 'Phê duyệt', deadlines: 'Hạn tuân thủ', requests: 'Yêu cầu đổi tên / chuyển nhượng' },
      subs: {},
    },
    domains: {
      label: 'Tên miền',
      description: 'Danh mục tên miền và mọi việc quanh tên miền: chuyển tên miền, đổi chủ thể và liên hệ.',
      tabs: { list: 'Danh sách', lookup: 'Tra cứu tên miền', transfers: 'Chuyển tên miền', 'registrant-changes': 'Đổi chủ thể', contacts: 'Liên hệ' },
      subs: {},
    },
    customers: {
      label: 'Khách hàng',
      description: 'Tài khoản khách hàng và hạng của họ, chủ thể đứng tên tên miền, hồ sơ và giấy tờ.',
      tabs: { customers: 'Khách hàng', subjects: 'Chủ thể', dossiers: 'Hồ sơ', documents: 'Giấy tờ' },
      subs: {},
    },
    sales: {
      label: 'Bán hàng & tài chính',
      description: 'Báo giá, đơn hàng, hoá đơn, thanh toán và ví.',
      tabs: { quotes: 'Báo giá', orders: 'Đơn hàng', invoices: 'Hoá đơn', payments: 'Thanh toán', 'bank-transactions': 'Giao dịch ngân hàng', ledger: 'Sổ cái / ví', subscriptions: 'Dịch vụ', overview: 'Tổng quan' },
      subs: {},
    },
    products: {
      label: 'Sản phẩm & giá',
      description: 'Bán gì và bán giá bao nhiêu: từng TLD cùng mức sẵn sàng, danh mục sản phẩm (hosting, máy chủ ảo, email …), bảng giá, khuyến mãi, dịch vụ tên miền và thuế suất.',
      tabs: { tlds: 'TLD', pricing: 'Bảng giá', promotions: 'Khuyến mãi', services: 'Add-on & phí', tax: 'Thuế suất', quote: 'Tính thử báo giá', catalog: 'Danh mục TLD', 'product-catalog': 'Danh mục sản phẩm' },
      subs: { 'product-catalog': { products: 'Sản phẩm & gói', 'server-groups': 'Nhóm máy chủ', locations: 'Vị trí', 'service-quote': 'Tính thử dịch vụ', 'price-rules': 'Giá theo hạng & giá riêng', 'promotion-scopes': 'Khuyến mãi dịch vụ' } },
    },
    backorder: {
      label: 'Backorder',
      description: 'Tên miền sắp được giải phóng, khách đang chờ, việc giành đăng ký lúc giải phóng và khoản tiền giữ chỗ trong lúc chờ.',
      tabs: { overview: 'Tổng quan', drops: 'Sắp giải phóng', requests: 'Yêu cầu', catching: 'Giành đăng ký', holds: 'Giữ chỗ & hoàn trả' },
      subs: {},
    },
    auctions: {
      label: 'Đấu giá tên miền',
      description: 'Phiên đấu giá, điều hành phiên, mọi lượt đặt giá, quyết toán và bàn giao tên miền cho người thắng.',
      tabs: { market: 'Phiên đấu giá', sessions: 'Tạo & quản lý phiên', bids: 'Lượt đặt giá & audit', settlement: 'Quyết toán', handover: 'Bàn giao' },
      subs: {},
    },
    compliance: {
      label: 'Tuân thủ',
      description: 'Báo cáo cơ quan nhà nước (qua VNNIC), nghĩa vụ ICANN, lạm dụng, tranh chấp, khoá pháp lý và chính sách.',
      tabs: { vnnic: 'Báo cáo nhà nước', icann: 'ICANN', cases: 'Vụ việc', policies: 'Chính sách' },
      subs: {
        vnnic: { 'dossier-sync': 'Gửi hồ sơ tên miền', 'international-reports': 'Báo cáo tên miền quốc tế', coverage: 'Đối chiếu', corrections: 'Cần đính chính', 'post-operations': 'Sau nghiệp vụ', 'registrar-signature': 'Chờ NĐK ký', 'tracking-reports': 'Báo cáo hằng ngày' },
        icann: { rdap: 'RDAP', rde: 'RDE (ký quỹ)', disclosure: 'Công bố dữ liệu' },
        cases: { inbox: 'Tất cả vụ việc', abuse: 'Lạm dụng', disputes: 'Tranh chấp', 'legal-locks': 'Khoá pháp lý' },
      },
    },
    ops: {
      label: 'Registry & vận hành',
      description: 'Vì sao một việc thất bại và hệ thống có khoẻ không: lệnh gửi registry, đối soát, thông báo từ registry, quy trình, cảnh báo và số liệu giám sát.',
      tabs: { overview: 'Tổng quan', registry: 'Registry', queues: 'Quy trình & hàng đợi', alerts: 'Cảnh báo & sự cố', services: 'Dịch vụ', telemetry: 'Số liệu giám sát', slo: 'Mục tiêu chất lượng' },
      subs: {
        registry: { registries: 'Registry', transactions: 'Lệnh gửi registry', reconciliation: 'Đối soát', poll: 'Thông báo từ registry', sessions: 'Phiên kết nối', epp: 'Cấu hình kết nối', health: 'Tình trạng' },
        queues: { queues: 'Hàng đợi', workflows: 'Quy trình' },
        alerts: { alerts: 'Cảnh báo', incidents: 'Sự cố' },
        telemetry: { metrics: 'Số liệu', logs: 'Nhật ký', traces: 'Vết xử lý' },
      },
    },
    settings: {
      label: 'Cài đặt',
      description: 'Mọi cài đặt trong một danh sách tìm được; mỗi mục mở đúng một chỗ của nó.',
      tabs: { all: 'Tất cả cài đặt', domains: 'Tên miền & TLD', connections: 'Kết nối', modules: 'Module', notify: 'E-mail & thông báo', security: 'Tổ chức & nhân viên' },
      subs: {
        domains: { channels: 'Kênh đăng ký TLD', lifecycle: 'Vòng đời & chuyển về / khôi phục', parking: 'DNS đỗ', requirements: 'Bộ giấy tờ', declarations: 'Mẫu bản khai', 'document-types': 'Loại hồ sơ', 'trust-anchors': 'Chứng chỉ gốc tin cậy', 'declaration-checks': 'Kiểm tra bản khai', 'vn-zones': 'Quy định đuôi .vn' },
        connections: { registries: 'Registry & nhà đăng ký gốc', vnnic: 'VNNIC', smartca: 'SmartCA', captcha: 'Chống robot', ote: 'Bài kiểm tra OT&E', reporting: 'API báo cáo' },
        notify: { email: 'E-mail & mẫu thư', sent: 'E-mail đã gửi', zalo: 'Zalo ZNS', webhooks: 'Gửi sự kiện (webhook)' },
        security: { staff: 'Nhân viên', roles: 'Vai trò & quyền', 'api-keys': 'Khoá truy cập', audit: 'Nhật ký thao tác', logs: 'Lưu trữ log' },
      },
    },
  },
  ui: {
    registerDomain: 'Đăng ký tên miền cho khách',
    noAccess: 'Tài khoản của bạn chưa được mở trang nào ở đây.',
    quickActions: 'Thao tác nhanh',
    newCustomer: 'Tạo khách hàng',
    newSubject: 'Tạo chủ thể',
    goTo: 'Đi tới',
    actions: 'Thao tác',
    related: 'Liên quan',
    results: 'Kết quả',
    searching: 'Đang tìm…',
    orderHit: 'Đơn hàng · {{detail}}',
    invoiceHit: 'Hoá đơn · {{detail}}',
    openOrderById: 'Mở đơn hàng có mã này',
    openInvoiceById: 'Mở hoá đơn có mã này',
    domainFilter: {
      label: 'Lọc nhanh',
      all: 'Tất cả',
      active: 'Đang hoạt động',
      expiring30: 'Sắp hết hạn (30 ngày)',
      expiring7: 'Sắp hết hạn (7 ngày)',
      expired: 'Đã hết hạn',
      grace: 'Chờ gia hạn',
      redemption: 'Chờ chuộc lại',
      pendingDelete: 'Chờ xoá',
      protected: 'Bảo vệ',
    },
    ote: {
      title: 'Bài kiểm tra OT&E',
      subtitle: 'Bài kiểm tra chứng nhận của registry, chạy từ máy chủ OT&E với từng kết nối EPP.',
      open: 'Mở bài kiểm tra',
      none: 'Chưa có kết nối EPP nào.',
      connection: 'Kết nối',
      protocol: 'Giao thức',
      status: 'Trạng thái',
    },
    settingsLink: {
      title: 'Cài đặt cho TLD này',
      body: 'Các cài đặt này dùng chung cho mọi TLD và được sửa trong Cài đặt; biểu mẫu bên dưới là cùng một biểu mẫu.',
      open: 'Mở trong Cài đặt',
    },
    registryLink: {
      connection: 'Cài đặt kết nối',
      connectionHint: 'Thông tin đăng nhập, chứng chỉ và địa chỉ được sửa trong Cài đặt › Kết nối.',
      ote: 'Bài kiểm tra OT&E của registry này chạy từ trang kết nối.',
      openTests: 'Mở bài kiểm tra OT&E',
    },
  },
};
